const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/appointment';

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let errorMessage = fallbackMessage;
    try {
        const data = await response.json();
        errorMessage = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        // Ignore parsing error
    }

    console.error(`API Error: [${response.status}] ${errorMessage}`);
    throw new Error(errorMessage);
};

export const getServiceSlots = async (serviceId, branchId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/available-slots/${branchId}/${serviceId}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل المواعيد المتاحة");
    }
    return await response.json();
};

export const addAppointment = async (token, appointment) => {
    const response = await fetch(`${BASE_URL}${API_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(appointment),
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء حجز الموعد، يرجى المحاولة مرة أخرى");
    }

    return await response.json();
};

export const getCustomerAppointments = async (token) => {
    const response = await fetch(`${BASE_URL}${API_URL}/customer`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل مواعيد العميل");
    }

    return await response.json();
};

export const deleteAppointment = async (token, appointmentId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${appointmentId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء حذف الموعد");
    }

    return await response.json();
};

export const getAppointmentDetails = async (appointmentID) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${appointmentID}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل تفاصيل الموعد");
    }
    return await response.json();
};

export const updateAppointment = async (token, appointmentId, updatedData) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${appointmentId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(updatedData),
    });

    if (!response.ok) {
        await handleError(response, "فشل في تحديث بيانات الموعد");
    }

    return await response.json();
};

export const getAppointmentsForService = async (token, serviceId, branchId, startDate, endDate) => {
    const params = new URLSearchParams({
        serviceId,
        branchId,
        ...(startDate && endDate ? { startDate, endDate } : {}),
    }).toString();

    const response = await fetch(`${BASE_URL}${API_URL}/by-date-range?${params}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل المواعيد حسب التاريخ");
    }

    return await response.json();
};

export const cancelAppointment = async (token, appointmentId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${appointmentId}/cancel`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء إلغاء الموعد");
    }

    return true;
};

export const changeAppointmentStatus = async (token, appointmentId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${appointmentId}/status`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تغيير حالة الموعد");
    }

    return true;
};

export const getEmployeeBookings = async (token) => {
    const response = await fetch(`${BASE_URL}${API_URL}/employee/my-bookings`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل حجوزات الموظف");
    }

    return await response.json();
};
